<template>
    <div class="item2">
        <div class="title">{{title}}</div>
        <div class="cont">
            <div class="item" v-for="(item,index) in data" :key="index">
                <img :src="item.img ? item.img : ''" alt="">
                <p class="tit">{{item.title}}</p>
                <div>
                    <p>{{item.text}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        data: {
            type: Array,
            default: () => [],
        },
    },
    name: '',
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.item2 {
    width: 1200px;
    color: #131415;
    padding: 20px 0;
    .title {
        font-weight: bold;
        font-size: 24px;
        text-align: center;
        margin-bottom: 20px;
    }
    .cont {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .item {
            width: 380px;
            height: 130px;
            background-color: #f4f6f8;
            margin: 15px 0;
            position: relative;
            padding: 25px 12px;
            cursor: pointer;
            &:hover p {
               color: #8a1f94;
            }

            img{
                width: 30px;
                height: 30px;
                display: inline-block;
            }
            .tit{
                font-weight: bold;
                font-size: 16px;
                padding-left: 5px;
                display: inline-block;
                position: relative;
                top: -13px;
            }
            div p {
                font-weight: bold;
                line-height: 25px;
            }
        }
    }
}
</style>
